import { render, staticRenderFns } from "./REMOpway.vue?vue&type=template&id=7e1e80de&scoped=true&"
import script from "./REMOpway.vue?vue&type=script&lang=js&"
export * from "./REMOpway.vue?vue&type=script&lang=js&"
import style0 from "./REMOpway.vue?vue&type=style&index=0&id=7e1e80de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1e80de",
  null
  
)

export default component.exports